import { Body, Box, Button, Icon } from '@hover/blueprint';
import { iRotateCcw, iX } from '@hover/icons';
import React, { useState } from 'react';
import { useParams } from 'react-router';

import { useProfileQuery } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { buttonImpression, buttonPressed } from 'src/shared/telemetry';

import { RevertModal } from '../RevertPropertyDetailsModal/RevertModal';

export const RevertBanner: React.FC<{
  page: string;
  redirectUrl: string;
}> = ({ page, redirectUrl }) => {
  const t = useTranslate(TranslationNamespace.PROPERTY_DETAILS);
  const { data: profileData } = useProfileQuery();
  const orgId = profileData?.profile.user.orgs[0].id as number;
  const [showBanner, setShowBanner] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const { jobId } = useParams<{
    jobId: string;
  }>();

  const onDismiss = () => {
    setShowBanner(false);
  };

  const onGoNowClick = () => {
    const trackingData = {
      button_location: 'Top-center',
      page_or_screen_name: page,
      button_text: 'Go Now',
      primary_cta: true,
      item_type: 'link',
      org_id: orgId,
      job_id: jobId ? Number(jobId) : undefined,
    };
    buttonImpression(trackingData);
    setShowModal(true);
  };

  const onConfirmModal = (feedback: string) => {
    if (feedback) {
      const trackingData = {
        button_location: 'Top-center',
        page_or_screen_name: page,
        button_text: `Go Now`,
        primary_cta: true,
        job_id: jobId ? Number(jobId) : undefined,
        org_id: orgId,
        property_details_feedback: feedback,
      };
      buttonPressed(trackingData);
    }

    window.location.href = redirectUrl;
  };

  const onDismissModal = () => setShowModal(false);

  return showBanner ? (
    <>
      <RevertModal
        isOpen={showModal}
        onCancel={onDismissModal}
        onConfirm={onConfirmModal}
      />
      <Box
        alignItems="center"
        backgroundColor="primary.900"
        height="350"
        justifyContent="center"
        justifyItems="center"
        maxWidth="100%"
        width="100vw"
      >
        <Icon color="white" icon={iRotateCcw} size="small" />
        <Body color="white" size={400}>
          {t('switchHoverClassic')}
        </Body>
        <Button
          background="white"
          fill="outline"
          fontWeight={600}
          marginLeft={400}
          onClick={onGoNowClick}
          size="small"
        >
          {t('goNow')}
        </Button>
        <Icon
          color="white"
          fill="minimal"
          icon={iX}
          onClick={onDismiss}
          position="absolute"
          right="200"
          size="small"
        />
      </Box>
    </>
  ) : null;
};
